import type {
  LeadList,
  GetLeadListsRequest,
  LeadListPatch,
} from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type LeadListStore = StoreEntity<
  LeadList,
  'id',
  GetLeadListsRequest,
  LeadList,
  LeadListPatch
>;

export const useLeadListStore = apiStoreFactory<
  LeadListStore['entity'],
  LeadListStore['id'],
  LeadListStore['filter'],
  LeadListStore['createInput'],
  LeadListStore['updateInput']
>(
  STORE.LEAD_LIST,
  { entityIdKey: 'id' },
  {
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getLeadListsRaw(filter, { signal });
    },
    read: async (listId, { dialbunnyApi }) => {
      return await dialbunnyApi.getListList({ listId });
    },
    update: async (listId, leadListPatch, { dialbunnyApi }) => {
      return await dialbunnyApi.updateLeadList({
        listId,
        leadListPatch,
      });
    },
  },
);
